module.exports = __webpack_public_path__ + "img/comp.e9ec9bed.svg";